import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { CategoryDescription } from "./CategoryDescription";

interface CategoryCardProps {
  category: {
    id: string;
    name: string;
    icon: React.ComponentType<{ className?: string }>;
    platforms: string[];
  };
  isLoading: boolean;
  testingConnection: string | null;
  getPlatformStatus: (platformId: string) => 'connected' | 'idle' | 'error';
  onTest: (platformId: string) => void;
  secretsConfigured: Record<string, boolean>;
}

export const CategoryCard = ({
  category,
}: CategoryCardProps) => {
  const Icon = category.icon;

  return (
    <Card className="overflow-hidden">
      <CardHeader className="bg-muted/40">
        <CardTitle className="flex items-center gap-2">
          <Icon className="h-5 w-5" />
          {category.name}
        </CardTitle>
        <CardDescription>
          <CategoryDescription categoryId={category.id} />
        </CardDescription>
      </CardHeader>
      <CardContent className="p-6">
        {/* Platform cards are now rendered in IntegrationsGrouping */}
      </CardContent>
    </Card>
  );
};
